import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Image, Menu } from 'semantic-ui-react';
import { logoutStaff } from '../actions';
import logo from '../assets/img/logo.png'

class Header extends Component {

    handleItemClick = (e, { name }) => {
        this.props.history.push('/' + name);
    }

    handleStaffLogout = (e) => {
        e.preventDefault();
        this.props.firebaseApp.auth().signOut()
        .then(() => {
            this.props.logoutStaff();
            this.props.history.push('/');
        });
    }

    render() {
        const { activePage, user } = this.props;

        return (
            <Menu fixed='top'>
                <Image
                        src={logo}
                        height='40px'
                        // size='small'
                        style={{ margin: '10px' }}
                />
                <Menu.Item as='h4' header>
                    Manager
                </Menu.Item>
                <Menu.Item as='a' name='orders' active={activePage === 'orders'} onClick={this.handleItemClick.bind(this)}>ORDERS</Menu.Item>
                { user && ((user.role === 'ADMIN') || (user.role === 'MANAGER')) &&
                    <Fragment>
                        <Menu.Item as='a' name='products' active={activePage === 'products'} onClick={this.handleItemClick.bind(this)}>PRODUCTS</Menu.Item>
                        {/* <Menu.Item as='a' name='products_offline' active={activePage === 'products_offline'} onClick={this.handleItemClick.bind(this)}>PRODUCTS (Offline)</Menu.Item> */}
                        <Menu.Item as='a' name='misc' active={activePage === 'misc'} onClick={this.handleItemClick.bind(this)}>MISC</Menu.Item>
                        <Menu.Item as='a' name='vouchers' active={activePage === 'vouchers'} onClick={this.handleItemClick.bind(this)}>VOUCHERS</Menu.Item>
                        <Menu.Item as='a' name='sales' active={activePage === 'sales'} onClick={this.handleItemClick.bind(this)}>SALES</Menu.Item>
                        <Menu.Item as='a' name='holiday' active={activePage === 'holiday'} onClick={this.handleItemClick.bind(this)}>HOLIDAY</Menu.Item>
                    </Fragment>
                }
                <Menu.Item as='a' name='customers' active={activePage === 'customers'} onClick={this.handleItemClick.bind(this)}>CUSTOMERS</Menu.Item>
                <Menu.Item as='a' name='logins' active={activePage === 'logins'} onClick={this.handleItemClick.bind(this)}>LOGINS</Menu.Item>
                { user && (user.role === 'ADMIN') &&
                    <Menu.Item as='a' name='staffs' active={activePage === 'staffs'} onClick={this.handleItemClick.bind(this)}>STAFFS</Menu.Item>
                }
                {/* { user && (user.role === 'ADMIN') &&
                    <Menu.Item as='a' name='quotations' active={activePage === 'quotations'} onClick={this.handleItemClick.bind(this)}>QUOTATIONS</Menu.Item>
                } */}
                <Menu.Menu position='right'>
                    <Dropdown item simple text={user.name} icon='user'>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={this.handleStaffLogout.bind(this)}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
        )
    }
}

const mapStateToProps = ({ main, auth }) => {
    return {
        activePage: main.activePage,
        firebaseApp: auth.firebaseApp,
        user: auth.user
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        logoutStaff: logoutStaff
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(Header);